module.exports = __webpack_public_path__ + "images/foot_txt-da12074e8ef6a8c19c15a4fefbbb1e37.png";